import React from "react"
import PropTypes from "prop-types"
import { graphql, Link,StaticQuery } from "gatsby"
import GuideStarComponent from "./guideStarComponent"
import GuideTermsComponent from "./guideTermsComponent"

const GuideTermsComponentRows = ({Terms}) => (
  <StaticQuery
    query={graphql`
    {
      allBilforsikring2020Csv(sort: {fields: Provider, order: ASC}){
        edges {
          node{
            Provider
            Product
            Defaqto_Stjerne
          }
        }
      }
    }
    `}
    render={data => (
    <>
        <div className="row" data-container="container">
            <div className="moto-widget moto-widget-row__column moto-cell col-sm-12 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
                <div className="moto-widget moto-widget-row moto-spacing-top-small moto-spacing-right-auto moto-spacing-bottom-medium moto-spacing-left-auto" data-grid-type="sm" data-widget="row" data-spacing="sama" style={{backgroundColor: 'transparent'}} data-bg-position="left top" data-draggable-disabled>
                    <div className="container-fluid">
                        <div className="row" data-container="container">

                            <div className="moto-widget moto-widget-row__column moto-cell col-sm-6 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">

                                {Terms.map((term,i) => (
                                    <>
                                        {i < Math.floor(Terms.length/2) && <GuideTermsComponent key={i} TermCategory={term.t} TermText={term.c}/>}
                                    </>
                                ))}

                            </div>

                            <div className="moto-widget moto-widget-row__column moto-cell col-sm-6 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">

                                {Terms.map((term,i) => (
                                  <>
                                      {i >= Math.floor(Terms.length/2) && <GuideTermsComponent key={i} TermCategory={term.t} TermText={term.c}/>}
                                  </>
                                ))}

                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    )}
    />
)

export default GuideTermsComponentRows